import React, { Fragment } from 'react';

const sameCategory = (item, index, array) => index > 0 && array[index - 1].category === array[index].category || item.showAll;

const SearchResult = ({ result, selectedItem, searchUrl }) => (
    <ul className="search-result">
        {result && result.map((item, index, array) => (
            <Fragment key={`${item.name}-${index}`}>
                {/* {item.category === 'NoHit' || sameCategory(item, index, array) ? null :
                    <li className="search-results__item search-results__group-header" >{ item.category }</li>
                } */}
                <li className={`search-result__item ${selectedItem === index ? 'search-result__item--selected' : ''}  search-result__item--${item.category.theme}`} >
                    <a className={item.showAll ? 'search-result__show-all' : `search-result__link ${item.url ? '' : 'search-result__link--disabled'}`}
                        href={item.showAll ? searchUrl : item.url}>
                        {item.hasImage && item.imageSource && <img className="search-result__image" src={item.imageSource} />}
                        <div className="search-result__info">
                            <div className="search-result__name">{item.name}</div>
                            {item.showAll ? '' : 
                            <div className="search-result__description">
                                {/*<span className="search-result__article-number">artikelnummer</span>*/}
                                {item.description}
                            </div>}
                        </div>
                    </a>
                </li>
            </Fragment>
        ))}
    </ul>
)

export default SearchResult;